import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Attribute } from 'src/app/models/product-models/views/Attribute';
import { AttributeValue } from 'src/app/models/product-models/views/AttributeValue';
import { Product } from 'src/app/models/product-models/views/Product';
import { getLocalizedString } from 'src/app/utils/Utils';
import { HIDDEN_WITHOUT_REFERENCES } from '../attribute/attribute.component';
import { ReferenceControllerService } from '../services/reference-controller.service';

@Component({
  selector: 'app-attribute-value',
  templateUrl: './attribute-value.component.html',
  styleUrls: ['./attribute-value.component.scss'],
})
export class AttributeValueComponent implements OnInit {
  @Input() attributeValue?: AttributeValue;
  @Input() product?: Product;
  @Input() attribute?: Attribute;
  @Input() isSet = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  @Output() valueSelected: EventEmitter<AttributeValueOutput> = new EventEmitter<AttributeValueOutput>();

  public get thumbnailURL() {
    return this.attributeValue && this.attributeValue.thumbnailUrl ? this.attributeValue.thumbnailUrl : '';
  }

  public get hideName() {
    return this.attribute?.displayParameters?.settings?.hideName;
  }

  public get attributeValueName() {
    if (!this.attributeValue || !this.attributeValue.infoText) return '';
    return getLocalizedString(this.attributeValue.infoText, this.translate);
  }

  public showAttributeValue(attribute: Attribute | undefined, attributeValue: AttributeValue | undefined) {
    if (attribute === undefined) return false;
    if (attributeValue === undefined) return false;
    if (attribute.displayParameters && attribute.displayParameters[HIDDEN_WITHOUT_REFERENCES] === true) {
      if (this.referenceControllerService.checkIfAttributeAndValueReferenceAnything(attribute, attributeValue)) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }

  constructor(
    private referenceControllerService: ReferenceControllerService,
    private translate: TranslateService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => this.changeDetector.markForCheck());
  }

  public get isAvailable() {
    return true;
    /*if (!this.product) return true;
    if (!this.attributeValue || !this.attribute) return true;
    const isReferenceAttributeValueAvailable = this.referenceControllerService.isReferenceAttributeValueAvailable(
      this.product,
      this.attribute,
      this.attributeValue,
    );
    if (isReferenceAttributeValueAvailable) return true;
    return false;*/
  }
}

export interface AttributeValueOutput {
  attribute?: Attribute;
  attributeValue?: AttributeValue;
}
